<!-- 配送设置 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <div class="top-title flex">音响设置<span class="color"></span></div>
        <div class="flex inline">
          <div class="title">音箱设备编号（SN）：</div>
          <el-input size="small" v-model="sn"></el-input>
        </div>
      </div>
      <div class="bottom">
        <div>
          提示: 请正确填写;
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="add">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAround, setAround } from "@/api/set";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "merch_id", "app_id"])
  },
  data() {
    return {
      sn: "" //编号
    };
  },
  created() {
    this.details();
  },
  methods: {
    add() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        sn: this.sn
      };
      setAround(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    details() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      getAround(data).then(res => {
        if (res.code == 200) {
          this.sn = res.data.sn;
        } else {
          this.$message.warning(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  /* padding: 0 48px 48px 27px; */
  background: #f0f2f5;
  .bodycontent {
    padding: 20px 26px 11px 20px;
    height: 100vh;
    border: 1px solid #f1f1f1;
    overflow: auto;
    min-width: 900px;
    background: rgba(240, 242, 245, 1);
    .top {
      width: 100%;
      height: 118px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      padding: 0 24px;
      .top-title {
        height: 50%;
        border-bottom: 1px dashed #eee;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.75);
        .color {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .inline {
        .title {
          width: 180px;
          text-align: right;
        }
        height: 50%;
        width: 480px;
      }
    }
    .bottom {
      margin: 18px 0 20px 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      > div {
        line-height: 20px;
      }
    }
    .btn {
      margin-top: 48px;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
</style>
